const POSITIVE_NEUTRAL_ADJECTIVES = [
    'Able', 'Bright', 'Calm', 'Clever', 'Cool', 'Curious', 'Daring', 'Eager', 'Fair', 'Friendly',
    'Gentle', 'Happy', 'Honest', 'Jolly', 'Keen', 'Kind', 'Lively', 'Lucky', 'Mellow', 'Merry',
    'Nimble', 'Noble', 'Patient', 'Polite', 'Proud', 'Quick', 'Quiet', 'Ready', 'Shiny', 'Smart',
    'Solid', 'Steady', 'Sunny', 'Swift', 'Tidy', 'Trusty', 'Upbeat', 'Vivid', 'Warm', 'Witty',
    'Agile', 'Bold', 'Brave', 'Chill', 'Cosmic', 'Easy', 'Fresh', 'Grand', 'Humble', 'Neat'
];

const RANDOM_NOUNS = [
    'Otter', 'Falcon', 'Panda', 'Tiger', 'Koala', 'Fox', 'Wolf', 'Eagle', 'Raven', 'Sparrow',
    'Dolphin', 'Whale', 'Shark', 'Turtle', 'Lynx', 'Bison', 'Moose', 'Hawk', 'Comet', 'Meteor',
    'Galaxy', 'Nova', 'Orbit', 'Pixel', 'Rocket', 'Beacon', 'Compass', 'Anchor', 'Clover', 'Maple',
    'Pebble', 'Canyon', 'River', 'Forest', 'Summit', 'Harbor', 'Echo', 'Drift', 'Breeze', 'Thunder',
    'Quartz', 'Topaz', 'Copper', 'Silver', 'Jade', 'Ruby', 'Onyx', 'Quartzite', 'Marble', 'Granite'
];

const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ');

const pick = (items) => items[Math.floor(Math.random() * items.length)];

const truncateAliasBase = (value, suffix, maxLength = 40) => {
    const normalized = normalize(value);
    const allowedBaseLength = Math.max(2, maxLength - String(suffix || '').length);
    if (normalized.length <= allowedBaseLength) return normalized;
    return normalize(normalized.slice(0, allowedBaseLength));
};

export const isPlayerOneName = (value) => normalize(value).toLowerCase() === 'player 1';

export const generateRandomGuestAlias = () => `${pick(POSITIVE_NEUTRAL_ADJECTIVES)} ${pick(RANDOM_NOUNS)}`;

export const ensureAliasWithSuffix = (desiredAlias, activeAliases = [], maxLength = 40) => {
    const normalizedDesired = normalize(desiredAlias) || 'Guest';
    const taken = new Set(activeAliases.map((alias) => normalize(alias).toLowerCase()).filter(Boolean));

    if (!taken.has(normalizedDesired.toLowerCase())) {
        return truncateAliasBase(normalizedDesired, '', maxLength);
    }

    for (let index = 2; index < 1000; index += 1) {
        const suffix = ` (${index})`;
        const base = truncateAliasBase(normalizedDesired, suffix, maxLength) || 'Guest';
        const candidate = `${base}${suffix}`;
        if (!taken.has(candidate.toLowerCase())) {
            return candidate;
        }
    }

    const fallbackSuffix = ` (${Date.now().toString().slice(-4)})`;
    const fallbackBase = truncateAliasBase('Guest', fallbackSuffix, maxLength) || 'Guest';
    return `${fallbackBase}${fallbackSuffix}`;
};

export const buildAutoJoinAlias = ({
    typedAlias = '',
    storedAlias = '',
    isAuthenticated = false,
    activeAliases = []
}) => {
    const normalizedTyped = normalize(typedAlias);
    const normalizedStored = normalize(storedAlias);
    const shouldAutoAssign = !isAuthenticated || !normalizedTyped || isPlayerOneName(normalizedTyped) || isPlayerOneName(normalizedStored);
    const baseAlias = shouldAutoAssign
        ? generateRandomGuestAlias()
        : normalizedTyped;
    return ensureAliasWithSuffix(baseAlias, activeAliases);
};

